import axios from 'axios';

export const createShiftConfiguration = async (config) => {
    try {
        const res = await axios(config)
        return res.data
    } catch (error) {
        return error
    }
}